export enum ProjectType {
  FIX = 'Fix',
  MOBIL = 'Mobil',
}
